import { forwardRef, ReactNode, Ref } from 'react';

import { Slide, SlideProps } from '@mui/material';

const SlideUpTransition = forwardRef(function SlideUpTransition(
  props: SlideProps & { children?: ReactNode },
  ref: Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default SlideUpTransition;
